// Dedicated, website-restricted Maps key (not the Firebase key).
export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_APIKEY ?? "";

export const GOOGLE_PLACES_SEARCH_TYPES = [
  "bar",
  "night_club",
  "point_of_interest",
  "route",
  "premise",
];
export const GOOGLE_PLACES_ESTABLISHMENT_TYPES = [
  "bar",
  "establishment",
  "night_club",
  "point_of_interest",
];

export const googlePrediction = async (input: string) => {
  if (typeof google === "undefined") return [];
  const { suggestions } =
    await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
      { input },
    );

  return suggestions.flatMap(({ placePrediction }) =>
    placePrediction ? [placePrediction] : [],
  );
};

export const googleGeocoder = async (placeId: string) => {
  if (typeof google === "undefined") return [];
  const geocoder = new google.maps.Geocoder();

  const { results } = await geocoder.geocode({ placeId, language: "en" });

  return results;
};

export const GOOGLE_MAP_PIN_ICON = {
  path: `M9 4C11.7614 4 14 6.23858 14 9C14 11.7614 11.7614 14 9 14C6.23858 14 4 11.7614 4 9C4 6.23858 6.23858 4 9 4ZM9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5Z
  M9.65773 21.7533L9 22.3276L8.34227 21.7533C2.81131 16.9237 0 12.7068 0 9C0 3.75066 4.09705 0 9 0C13.9029 0 18 3.75066 18 9C18 12.7068 15.1887 16.9237 9.65773 21.7533ZM1 8.92599C1 12.1521 3.63613 16.2106 9 21C14.3639 16.2106 17 12.1521 17 8.92599C17 4.27978 13.3839 1 9 1C4.61613 1 1 4.27978 1 8.92599Z`,
  fillOpacity: 1,
  fillColor: "#000000",
  scale: 1.4,
};

// Offline lookup: the Time Zone API rejects website-restricted keys.
export const getTimeZoneIdByGeocode = async (lat: number, lng: number) => {
  const { default: tzlookup } = await import("@photostructure/tz-lookup");
  return tzlookup(lat, lng);
};
